<template>
  <validation-observer ref="simpleRules">
    <corporate-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import CorporateItemForm from '@/views/Admin/Corporate_policies/Components/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    CorporateItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
    saveData() {
      return this.$store.getters['corporatePolicies/dataSaveStatus']
    },
    itemList() {
      return this.$store.getters['corporatePoliciesItems/dataList']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/app/corporate-policies')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('corporatePolicies/getDataItem', this.$route.params.id)
        .then(res => {
          if (res) {
            this.$store.dispatch('corporatePoliciesItems/getDataList', {
              select: [
                'corporate_policies_items.id AS id',
                'corporate_policies_items.title AS title',
                'corporate_policies_items.content AS content',
              ],
              where: {
                'corporate_policies_items.id_corporate_policies': res.id,
              },
            })
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          if (this.itemList.length > 0) {
            this.itemData.items = this.itemList
          }
          this.$store.dispatch('corporatePolicies/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
